var _g, _defs, _mask, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg03BmwSpeedometer5YcDeliveryMotorcycles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 356",
    enableBackground: "new 0 0 290 356",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout"
  }, /*#__PURE__*/React.createElement("line", {
    id: "baseline-1",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    x1: 60,
    y1: 333.5,
    x2: 222,
    y2: 333.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFiltercd",
    filterUnits: "userSpaceOnUse",
    x: 66,
    y: 76,
    width: 150,
    height: 251
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 76,
    width: 150,
    height: 251,
    id: "_x35_y_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFiltercd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 76,
    width: 9,
    height: 251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 76,
    width: 9,
    height: 251
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_y_1_",
    mask: "url(#_x35_y_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x34_y",
    d: "M75,327h-9V124h9V327z M111,98h-9v229h9V98z M146,95h-9v232h9V95z M181,76h-9v251h9V76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x35_y",
    fill: "#006BB0",
    d: "M216,327h-9V85h9V327z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "total-pin",
    fill: "none",
    stroke: "#006BB0",
    strokeMiterlimit: 10,
    points: "215.5,86 227,36 290,36  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 203 351.7695)",
    fill: "#006BB0",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "10px"
  }, "2020"), /*#__PURE__*/React.createElement("text", {
    id: "kpi-total",
    transform: "matrix(1 0 0 1 238.4155 31.5234)",
    fill: "#006BB0",
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "15px"
  }, "169,272"), /*#__PURE__*/React.createElement("text", {
    id: "head-total_1_",
    transform: "matrix(1 0 0 1 33.0234 82.1387)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "7px"
  }, "in units"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03BmwSpeedometer5YcDeliveryMotorcycles);
export default __webpack_public_path__ + "static/media/03_BMW_speedometer-5YC-delivery-motorcycles.feb51208.svg";
export { ForwardRef as ReactComponent };